import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Banner } from 'src/app/model/shared/banner';
import { SharedDataService } from 'src/app/service/shared-data.service';

@Component({
  selector: 'app-operational-assurances-page',
  templateUrl: './operational-assurances-page.component.html',
  styleUrls: ['./operational-assurances-page.component.scss']
})
export class OperationalAssurancesPageComponent implements OnInit {
  pageTitle = '';
  banner: Banner = {} as Banner;

  constructor(private activatedRoute: ActivatedRoute, private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => (this.pageTitle = params['pageTitle']));

    this.sharedDataService.sharedData.subscribe((banner) => {
      this.banner = banner;
    });
  }
}
